import { render, staticRenderFns } from "./circulationRecord.vue?vue&type=template&id=0800e35c"
import script from "./circulationRecord.vue?vue&type=script&lang=js"
export * from "./circulationRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports